import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  generateKey,
} from "../utils/setting";
import { Cookies } from "react-cookie";
import Uuid from "uuid/v1";
import { checkResponse } from "../utils/checkResponse";
const cookie = new Cookies();
const fcm = {
  state: {
    fcmToken: "",
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    disconnectFCM(payload, rootState) {
      return fetch(DomainAPI + Channel + "/api/secure/fcm/disconnectFCM", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: payload,
        },
        body: JSON.stringify({
          uuid: cookie.get("uuid"),
          // fcmToken: rootState.fcm.fcmToken
        }),
      })
        .then((res) => res.json())
        .then(async (result) => {
          checkResponse(result, dispatch);
          return result.code === 1 ? true : false;
        })
        .catch((err) => {
          return false;
        });
    },
    async saveFcmToken(payload, rootState) {
      const _this = this;
      let uuid;
      if (cookie.get("uuid")) uuid = cookie.get("uuid");
      else {
        let uuid_value = Uuid();
        uuid = uuid_value;
        cookie.set("uuid", uuid_value, { path: "/" });
      }
      payload.uuid = uuid;
      return fetch(DomainAPI + Channel + "/api/secure/fcm/saveFcmToken", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({ fcmToken: payload.fcmToken });
            return true;
          }
          return false;
        })
        .catch((error) => {
          return false;
        });
    },
  }),
};

export default fcm;
